__webpack_require__.p = "https://ricohapp.ricoh.co.th/warranty/";